<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb" />
    <div class="wrap max-width">
      <div class="product-container">
        <div class="search-header">
          <div class="box-title">产品列表</div>
          <el-input v-model="dataForm.prodtName" style="width: 400px" placeholder="请输入">
            <el-button slot="append" icon="el-icon-search" type="primary" @click="getProductList">查询</el-button>
          </el-input>
        </div>
        <div class="filter-item">
          产品类型：<span
            v-for="item in prodtTypeList"
            :key="item.cd"
            class="item-type"
            :class="[dataForm.prodtType === item.cd ? 'active' : '']"
            @click="selectType(item)"
            >{{ item.nm }}</span
          >
        </div>
        <div class="flex-box">
          <ProductCard v-for="item in list" :key="item.id" :need-collect="true" class="ans-box" :item="item" @refresh="getProductList" />
        </div>
        <div v-if="list.length === 0" class="no-msg">暂无产品</div>
        <el-pagination
          v-if="list.length"
          layout="prev, pager, next"
          :current-page="page.pageNo"
          :page-size="page.pageSize"
          :background="true"
          :total="total"
          @current-change="currentChangeHandle"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import ProductCard from '@/components/ProductCard'
export default {
  components: { Breadcrumb, ProductCard },
  data() {
    return {
      prodtTypeList: [],
      page: {
        pageNo: 1,
        pageSize: 12,
      },
      total: 0,
      list: [],
      dataForm: {
        prodtType: '',
      },
      breadcrumb: [
        {
          path: '/',
          name: '首页',
          meta: {
            title: '首页',
          },
        },
        {
          path: '/product/list',
          name: '企业产品列表',
          meta: {
            title: '企业产品列表',
          },
        },
      ],
    }
  },
  mounted() {
    this.getProductList()
    this.getEnum('ZzmhProductEn$ProdtType', 'prodtTypeList')
  },
  methods: {
    getEnum(code, key) {
      this.$http({ method: 'get', url: `/general/enum/list?cls=${code}` }).then((res) => {
        this[key] = [{ nm: '全部', cd: '' }, ...res.data.list]
      })
    },
    handleSizeChange(val) {
      this.page.pageNo = 1
      this.page.pageSize = val
      this.getProductList()
    },
    currentChangeHandle(val) {
      this.page.pageNo = val
      this.getProductList()
    },
    selectType(item) {
      this.dataForm.prodtType = item.cd
      this.getProductList()
    },
    getProductList() {
      let query = this.$query.new()
      this.$query.toF(query, this.dataForm)
      this.$query.toP(query, this.page.pageNo, this.page.pageSize)
      let params = {}
      this.$http({ method: 'get', url: '/zzmh/in/product/page?query=' + encodeURIComponent(this.$query.toJsonStr(query)), params }).then((res) => {
        console.log(res)
        this.list = res.data.list
        this.total = res.page.total
      })
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .no-msg {
    margin: 50px 0;
    text-align: center;
  }
  .wrap {
    display: flex;
    flex-direction: column;
  }
  .product-container {
    background: #fff;
    padding: 20px;
  }
  .search-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333333;
    margin-bottom: 16px;
    .box-title {
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 600;
    }
  }
  .filter-item {
    color: #333;
    font-size: 16px;
    padding-bottom: 20px;
  }
  .flex-box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    overflow: hidden;
    white-space: nowrap;
  }
  .ans-box {
    border: 1px solid #eee;
    margin-bottom: 20px;
    width: 207px;
    margin-right: 10px;
  }

  .item-type {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #666666;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    margin-right: 16px;
    cursor: pointer;
    &.active {
      color: #1b5bfa;
      font-family: PingFangSC-Semibold;
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
